<template>
	<div id="app" :class="{ 'is-full-viewport': isFullViewport }" :style="appStyle">
	  <router-view />
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueRouter from "vue-router"
	Vue.use(VueRouter);
	export default {
		props: {
		    width: {
		      type: Number,
		      default: 1920,
		    },
		    height: {
		      type: Number,
		      default: 919,
		    },
			rotate: {
			  type: Number,
			  default: 0,
			},
		},
	    data() {
		  return {
			  scaleX: 1,
			  scaleY: 1,
			  currentHeight:0,
			  currentWidth:0,
			  timer:null
		  }
		},
		computed: {
			isFullViewport() {
				const matchedRoutes = this.$route && Array.isArray(this.$route.matched)
					? this.$route.matched
					: [];
				const isMobileViewport = this.currentWidth > 0 && this.currentWidth <= 760;
				return matchedRoutes.some(routeRecord => {
					const routeMeta = routeRecord.meta || {};
					return routeMeta.fullViewport || (routeMeta.mobileFullViewport && isMobileViewport);
				});
			},
			appStyle() {
				if (this.isFullViewport) {
					return {
						transform: 'none',
						WebkitTransform: 'none',
						transformOrigin: '0 0',
						width: '100vw',
						height: '100vh'
					};
				}
				return {
					transform: `scale(${this.scaleX}, ${this.scaleY}) rotate(${this.rotate}deg)`,
					WebkitTransform: `scale(${this.scaleX}, ${this.scaleY}) rotate(${this.rotate}deg)`,
					transformOrigin: '0 0',
					width: `${this.width}px`,
					height: `${this.height}px`
				};
			}
		},
		mounted() {
			this.updateScreenWidth();
			window.addEventListener('resize', this.updateScreenWidth);
		},
		beforeDestroy() {
		  window.removeEventListener('resize', this.updateScreenWidth);
		},
		methods:{
			
			getScale() {
				var e = window, a = 'inner';
				if (!('innerWidth' in window )) {
				    a = 'client';
				    e = document.documentElement || document.body;
				}
				console.log("高度:"+e[ a+'Height' ]+"_宽度:"+e[ a+'Width' ]);
			  let ww = (e[ a+'Width' ] + 0) / this.width;
			  let wh = (e[ a+'Height' ] + 0) / this.height;
			  this.scaleX = ww;
			  this.scaleY = wh;
			},
			updateScreenWidth() {
			  this.currentWidth = window.innerWidth || document.documentElement.clientWidth || 0;
			  this.currentHeight = window.innerHeight || document.documentElement.clientHeight || 0;
			  this.getScale();
			},
			debounce(func, delay) {
			  return (...args) => {
				if (this.timer) clearTimeout(this.timer) // 清除上一次的定时器
				this.timer = setTimeout(() => {
				  func(...args)
				}, delay)
			  }
			},
			setScale() {
			  this.debounce(() => {
				this.scale = this.getScale()
			  }, 500)()
			},
		}
	}
</script>
<style>
	.v-modal {
	    position: fixed;
	    left: 0;
	    top: 0;
	    width: 100%;
	    height: 100%;
	    opacity: .5;
	    background: rgba(255, 0, 0, 0) !important;
	}
	.a-line{
		height: 1px;
		background: #E8E8E8;
		width: 100%;
	}
	/* 通用表格 css 配置 开始 */
	.a-edit-form-row-left{
		width: 100px;
		margin-left: 48px;
		margin-top: 10px;
	}
	.a-edit-form-row-left-text{
		height: 20px;
		font-size: 14px;
		font-weight: 400;
		color:#000000;
		line-height: 20px;
		opacity: 0.45;
	}
	.a-edit-form-row-right{
		margin-left: 16px;
	}
	.a-edit-form-row{
		display: flex;
		height: 36px;
		margin-top: 24px;
	}
	.a-form-table{
		padding: 10px;
		overflow-y: auto;
		height: 620px;
	}
	.a-form-header-right-right{
		width: 85px;
		height: 34px;
		background: var(--solar-primary, #1890FF);
		margin-left: 8px;
		border-radius: 2px;
		text-align: center;
		padding-top: 7px;
		cursor: pointer;
		font-size: 14px;
		font-weight: 400;
		color: var(--solar-text-strong, #FFFFFF);
		line-height: 22px;
	}
	.a-form-header-right-left{
		width: 85px;
		height: 32px;
		background: #FFFFFF;
		border: 1px solid #D9D9D9;
		text-align: center;
		padding-top: 7px;
		cursor: pointer;
		font-size: 14px;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.65);
		line-height: 22px;
	}
	.a-form-header-right{
		margin-left: auto;
		margin-right: 10px;
		display: flex;
	}
	.a-form-header-left{
		margin-left: 10px;
	}
	.a-form-header{
		display: flex;
	}
	.a-form{
		height: 90%;
		background: #FFFFFF;
		border-radius: 2px;
		margin-left: 20px;
		width: -webkit-calc( 100% - 40px);
		margin-top: 20px;
	}
	/* 通用表格 css 配置 结束 */
	
	::-webkit-scrollbar {
		width: 4px;   
		height: 1px;
	} 
	/* 容器布局相关 */
	 html,body,#app,.el-container{
		/*设置内部填充为0，几个布局元素之间没有间距*/
		padding: 0px;
		 /*外部间距也是如此设置*/
		margin: 0px;
		/*统一设置高度为100%*/
		height: 100vh;
		overflow-x: hidden;
		overflow-y: hidden;
	}
	.el-menu-item.is-active{
		color: white!important; 
		background-color: var(--solar-primary, #1890FF)!important;
	}
	.el-container.is-vertical {
	    flex-direction: column;
	    /* height: 100vh; */
	}
	.el-aside{
		overflow: auto;
		box-sizing: border-box;
		flex-shrink: 0;
		margin-left: -8px;
		margin-top: -8px;
	}
	.el-main{
		display: block;
		flex: 1;
		flex-basis: auto;
		overflow: auto;
		padding: 0px !important;
		box-sizing: border-box;
		height: 877px;
	}
	.el-header{
		padding: 0 0px !important;
		box-sizing: border-box;
		flex-shrink: 0;
		margin-left: 2px;
	}
	/* el-tree 相关修改 */
	.el-tree-node__content{
		display: flex;
		align-items: center;
		height: 36px !important;
		cursor: pointer;
	}
	.is-current{
		background-color: rgb(255, 255, 255) !important;
	}
	.el-tree-node.is-current > .el-tree-node__content {
	  background-color: white !important;
	}
	/* tree 菜单 相关修改 */
	.el-menu{
		border-right: solid 0px #e6e6e6 !important;
		list-style: none;
		position: relative;
		margin: 0;
		padding-left: 0;
		background-color: #FFF;
	}
	.el-menu-item:focus{
		background-color: var(--solar-primary, #1890FF)!important;
		color: white!important;
	}
	.a-footer-div{
		text-align: center;
		bottom: 0px;
	}
</style>

